import { MNSproCloudApi } from '..';
import {
  CreateParentInvitationRequest,
  GuardianContactInvitationResponse,
} from '../api/v2';

export class ParentInvitationService {
  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ParentalCommunicationApiFactory(config);
    return api;
  }

  static async create(
    authToken: string,
    studentId: string,
    organizationId: string,
    options?: CreateParentInvitationRequest,
  ) {
    const api = ParentInvitationService.getApi(authToken);
    const request: CreateParentInvitationRequest = {
      oneTimeUse: options?.oneTimeUse,
      validFor: options?.validFor,
    };

    return await api.createParentInvitation(organizationId, studentId, request);
  }

  public static async getAllInvitations(
    authToken: string,
    organizationId: string,
    studentId: string,
  ): Promise<GuardianContactInvitationResponse[]> {
    const api = ParentInvitationService.getApi(authToken);
    const response = await api.getInvitationsFor(organizationId, studentId);

    return response.data;
  }

  public static async revokeInvitation(
    authToken: string,
    organisationId: string,
    inviationId: string,
  ) {
    const api = ParentInvitationService.getApi(authToken);
    const response = await api.revokeInvitation(organisationId, inviationId);
  }
}
